import React from 'react';
import { Table } from 'src/design/molecules/Table';

import { Currency } from 'src/design/atoms/Currency';
import { TOTAL_BG } from 'src/routes/CTC/ViewCTCJob/components/colors';

interface TotalObj {
  hours: number;
  rate: number;
  ctc: number;
  costAtCompletion: number;
  overUnder: number;
}
interface SummaryLineProps {
  totals: TotalObj;
  redBg?: boolean;
}

export const SummaryLine: React.FC<SummaryLineProps> = ({
  totals,
  redBg = false,
}) => {
  return (
    <Table.Tr>
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: redBg ? TOTAL_BG : '#f3f3f3',
        }}
        align="right"
        colSpan={1}
      />
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: redBg ? TOTAL_BG : '#f3f3f3',
        }}
        align="right"
        colSpan={1}
      />
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: redBg ? TOTAL_BG : '#f3f3f3',
        }}
        align="right"
        colSpan={1}
      />
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: redBg ? TOTAL_BG : '#f3f3f3',
        }}
        align="right"
        colSpan={1}
      >
        <b>{<Currency precise value={totals.ctc} />}</b>
      </Table.Td>
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: redBg ? TOTAL_BG : '#f3f3f3',
        }}
        align="right"
        colSpan={1}
      >
        <b>
          {totals.costAtCompletion < 0 ? (
            <span className="text-danger">
              ({<Currency precise value={totals.costAtCompletion * -1} />})
            </span>
          ) : (
            <Currency precise value={totals.costAtCompletion} />
          )}
        </b>
      </Table.Td>
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: redBg ? TOTAL_BG : '#f3f3f3',
        }}
        align="right"
        colSpan={1}
      >
        <b>
          {totals.overUnder < 0 ? (
            <span className="text-danger">
              ({<Currency precise value={totals.overUnder * -1} />})
            </span>
          ) : (
            <span
              className={totals.overUnder < 0 ? 'text-danger' : 'text-success'}
            >
              {<Currency precise value={totals.overUnder} />}
            </span>
          )}
        </b>
      </Table.Td>
    </Table.Tr>
  );
};
